export interface ElevationProfilePoint {
  distance_km: number;
  elevation_m: number;
}

// Высота профиля на каждой из distancesKm (линейная интерполяция). distancesKm
// по возрастанию (накопленная длина вдоль линии), points - профиль по
// возрастанию distance_km. Один проход двумя указателями: O(N + M), а не
// O(N * M), как при поиске по профилю с начала для каждой вершины, - линия
// редактора перерисовывается на каждый тап и кадр перетаскивания.
export function elevationsAtDistances(distancesKm: number[], points: ElevationProfilePoint[]): number[] {
  const out = new Array<number>(distancesKm.length);
  if (!points.length) return out.fill(NaN);
  const first = points[0];
  const last = points[points.length - 1];
  let j = 1;
  for (let k = 0; k < distancesKm.length; k++) {
    const d = distancesKm[k];
    if (d <= first.distance_km) {
      out[k] = first.elevation_m;
      continue;
    }
    if (d >= last.distance_km) {
      out[k] = last.elevation_m;
      continue;
    }
    // Первый индекс j >= 1 с points[j].distance_km >= d (j только растёт).
    while (j < points.length - 1 && points[j].distance_km < d) j++;
    const a = points[j - 1];
    const b = points[j];
    const span = b.distance_km - a.distance_km;
    const t = span > 0 ? (d - a.distance_km) / span : 0;
    out[k] = a.elevation_m + (b.elevation_m - a.elevation_m) * t;
  }
  return out;
}
